import { Box, ListSubheader, Select, styled } from '@mui/material';

import { MenuItemStyled, SelectStyled } from 'theSource/components/Select';
import { HEADER_HEIGHT } from 'theSource/components/Header/HeaderStyled';
import { NUM_DISPLAYED_ITEMS } from './utils/constants';

export const SearchableSelectStyled = styled(SelectStyled)(({ theme }) => ({
  '& .MuiPaper-root': {
    [theme.breakpoints.down('lg')]: {
      minWidth: '90vw !important',
    },
  },
  '& .MuiList-root': {
    paddingTop: 0,
    maxHeight: `${
      (theme.customSizes.menuItemHeight + theme.customSizes.menuItemSpacing) *
        NUM_DISPLAYED_ITEMS -
      theme.customSizes.menuItemSpacing * 2
    }rem`,
  },
})) as typeof Select;

export const ListSubheaderStyled = styled(ListSubheader)(({ theme }) => ({
  height: `${
    theme.customSizes.inputHeight + theme.customSizes.menuItemSpacing
  }rem`,
  '& .MuiOutlinedInput-root': {
    marginTop: `${theme.customSizes.menuItemSpacing}rem`,
  },
}));

export const HiddenMenuItemStyled = styled(MenuItemStyled)({
  display: 'none',
});

export const AnchorElementStyled = styled(Box)({
  position: 'absolute',
  top: `calc(-${HEADER_HEIGHT} - 1rem)`,
});
